import { render, staticRenderFns } from "./ModalProductSupport.vue?vue&type=template&id=7fba83f1&"
import script from "./ModalProductSupport.vue?vue&type=script&lang=js&"
export * from "./ModalProductSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports